import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UploadConfirmationComponent } from '../upload-confirmation/upload-confirmation.component';

@Component({
  selector: 'app-document-capture-footer',
  standalone: true,
  imports: [UploadConfirmationComponent],
  templateUrl: './document-capture-footer.component.html',
  styleUrl: './document-capture-footer.component.scss'
})
export class DocumentCaptureFooterComponent {
  @Input() isSubmitted: boolean = false;
  @Input() enableSubmitButton: boolean = false;
  
  @Output() submitClicked = new EventEmitter<void>();
}
